import React from 'react';
import clsx from 'clsx';
import type { CardProps } from './Card.types';
import { CardBody } from './CardBody';
import { CardHeader } from './CardHeader';
import { CardFooter } from './CardFooter';
import { CardTitle } from './CardTitle';
import { CardMedia } from './CardMedia';
import { CardMediaOverlay } from './CardMediaOverlay';
import { CardSubtitle } from './CardSubtitle';

const CardBase = React.forwardRef<HTMLElement, CardProps>(
  (
    { as: Component = 'div', theme, testId, className, children, ...restProps },
    ref
  ) => {
    return (
      <Component
        ref={ref}
        className={clsx('hg-card', className)}
        data-theme={theme}
        data-testid={testId}
        {...restProps}
      >
        {children}
      </Component>
    );
  }
);

CardBase.displayName = 'Card';

export const Card = Object.assign(CardBase, {
  Body: CardBody,
  Header: CardHeader,
  Footer: CardFooter,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Media: CardMedia,
  MediaOverlay: CardMediaOverlay,
});
